// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取学生天地搜索列表
export function articleSearchList(params) {
  return request({
    url: "/api/article/search_list",
    method: "get",
    params,
  });
}



// 在线学习-详情页面-视频播放量    
export function articlePlayNumber(params) {
  return request({
    url: "/api/article/play_number",
    method: "get",
    params,
  });
}



